import { useNavigate } from 'react-router-dom';
//import logoPositiv from '../img/logo-horizontal-positive.svg';
//import logoNegativ from '../img/logo-horizontal.svg';
import logoPositiv from '../img/asg aufmassdienst-positive.png';
import logoNegativ from '../img/asg aufmassdienst-positive.png';
//import logoNegativ from '../img/asg aufmassdienst-negative.png';

interface ThisProps {
  //  auftragUid: string,
}

const LogoComponent: React.FC<ThisProps> = (props) => {
  const navigate = useNavigate();

  return (
    <>
      <img
        style={{height: "6em"}}
        alt="s" src={window.location.pathname === '/' ? logoNegativ : logoPositiv}
        onClick={() => {
          navigate({
            pathname: '/'
          })
        }}
      />
    </>
  );
}

export default LogoComponent;
